import { lazy } from 'react';
import { authModules } from 'app/auth';
import ABSUtils from '@abs/utils/ABSUtils';
import themesConfig from 'app/configs/themesConfig';

const Calendar = lazy(() => import('./Calendar'));

const CalendarConfig = {
	settings: {
		layout: {
			config: {}
		},
		theme: {
			main: ABSUtils.IsDarkMode() ? themesConfig.timeliteDark : themesConfig.timelite,
			navbar: ABSUtils.IsDarkMode() ? themesConfig.timeliteDark : themesConfig.timelite,
		}
	},
	routes: [
		{
			path: '/tl/calendar',
			element: <Calendar />,
			auth: authModules.tl_default
		}
	]
};

export default CalendarConfig;
